import { NextPageContext } from 'next'
import Link from 'next/link'

import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import Panel from '@/components/Panel/Panel'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'

type Props = {
  statusCode?: number
}

export const StatusErrorPage = ({ statusCode }: Props) => (
  <Main>
    <Container small>
      <ExplicitHead description='Error on the server.' keywords='500' noindex title='Server Error' />
      <SimpleHeader>{statusCode} Error</SimpleHeader>
      <Panel>
        <p>The error has been recorded. New cards take a few days to show up on EDHREC.</p>
        <p>
          Otherwise, you can also <Link href='/bug-report'>report a bug</Link> to help us fix it faster.
        </p>
      </Panel>
    </Container>
  </Main>
)

const ServerErrorPage = ({ statusCode }: Props) => {
  if (!statusCode)
    return (
      <Main>
        <Container small>
          <ExplicitHead description='Error in the application.' keywords='500' noindex title='Application Error' />
          <SimpleHeader>Application Page Error</SimpleHeader>
          <Panel>
            <p>The error has been recorded. New cards take a few days to show up on EDHREC.</p>
            <p>
              Otherwise, you can also <Link href='/bug-report'>report a bug</Link> to help us fix it faster.
            </p>
          </Panel>
        </Container>
      </Main>
    )
  return <StatusErrorPage statusCode={statusCode} />
}

ServerErrorPage.getInitialProps = ({ err, res }: NextPageContext) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404
  return { statusCode }
}

export default ServerErrorPage
